import { render, staticRenderFns } from "./IntermediaryCard.vue?vue&type=template&id=86a1d662&scoped=true&"
import script from "./IntermediaryCard.vue?vue&type=script&lang=js&"
export * from "./IntermediaryCard.vue?vue&type=script&lang=js&"
import style0 from "./IntermediaryCard.vue?vue&type=style&index=0&id=86a1d662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a1d662",
  null
  
)

export default component.exports